namespace TabAurous.ECommerce {
    export interface ECommSalesRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        POSCustomerId?: number;
        TermsId?: number;
        BaseItemTypeId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        RoundOff?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        GSTState?: string;
        ItemDetails?: ECommSalesItemsRow[];
        TaxDetails?: ECommSalesTaxRow[];
        GiftDetails?: ECommSalesGiftVoucherRow[];
        ReceiptDetails?: ECommSalesReceiptRow[];
        PromoDetails?: ECommSalesPromoRow[];
        AddressDetails?: ECommOrderAddressRow[];
        PostingDate?: string;
        IsPosted?: boolean;
        PosCustomerCode?: string;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ImageName?: string;
        Receipt?: number;
        BalanceAmount?: number;
        CustomerName?: string;
        Email?: string;
        BirthDate?: string;
        Anniversary?: string;
        TaxId?: string;
        PanNumber?: string;
        Address?: string;
        Mobile?: string;
        ECommOrderId?: number;
        ECommOrderNo?: string;
        BillingCityName?: string;
        BillingCity?: number;
        BillingState?: number;
        BillingStateName?: string;
        BillingCountry?: number;
        BillingCountryName?: string;
        BillingAddress?: string;
        BillingPhone?: string;
        BillingPin?: string;
        ShippingAddress?: string;
        ShippingCity?: number;
        ShippingCityName?: string;
        ShippingState?: number;
        ShippingStateName?: string;
        ShippingCountry?: number;
        ShippingCountryName?: string;
        ShippingPincode?: string;
        ShippingPhone?: string;
    }

    export namespace ECommSalesRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ECommerce.ECommSales';
        export const deletePermission = 'EComm:ECommSales:Delete';
        export const insertPermission = 'EComm:ECommSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSales:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            TermsId = "TermsId",
            BaseItemTypeId = "BaseItemTypeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            RoundOff = "RoundOff",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            GSTState = "GSTState",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails",
            GiftDetails = "GiftDetails",
            ReceiptDetails = "ReceiptDetails",
            PromoDetails = "PromoDetails",
            AddressDetails = "AddressDetails",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            PosCustomerCode = "PosCustomerCode",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ImageName = "ImageName",
            Receipt = "Receipt",
            BalanceAmount = "BalanceAmount",
            CustomerName = "CustomerName",
            Email = "Email",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            TaxId = "TaxId",
            PanNumber = "PanNumber",
            Address = "Address",
            Mobile = "Mobile",
            ECommOrderId = "ECommOrderId",
            ECommOrderNo = "ECommOrderNo",
            BillingCityName = "BillingCityName",
            BillingCity = "BillingCity",
            BillingState = "BillingState",
            BillingStateName = "BillingStateName",
            BillingCountry = "BillingCountry",
            BillingCountryName = "BillingCountryName",
            BillingAddress = "BillingAddress",
            BillingPhone = "BillingPhone",
            BillingPin = "BillingPin",
            ShippingAddress = "ShippingAddress",
            ShippingCity = "ShippingCity",
            ShippingCityName = "ShippingCityName",
            ShippingState = "ShippingState",
            ShippingStateName = "ShippingStateName",
            ShippingCountry = "ShippingCountry",
            ShippingCountryName = "ShippingCountryName",
            ShippingPincode = "ShippingPincode",
            ShippingPhone = "ShippingPhone"
        }
    }
}
